<div class="fd-totals-panel">
  <div class="fd-totals-row">
    <span>Subtotal</span>
    <span>${{ subtotal | number:'1.2-2' }}</span>
  </div>

  <ng-container *ngIf="!taxModeNone">
    <ng-container *ngIf="taxBreakdown.length; else singleTax">
      <div *ngFor="let t of taxBreakdown" class="fd-totals-row">
        <span>{{ t.taxName }}</span>
        <span>${{ t.taxAmount | number:'1.2-2' }}</span>
      </div>
    </ng-container>
    <ng-template #singleTax>
      <div class="fd-totals-row" *ngIf="taxTotal > 0">
        <span>Impuestos</span>
        <span>${{ taxTotal | number:'1.2-2' }}</span>
      </div>
    </ng-template>
  </ng-container>

  <mat-divider class="fd-totals-divider"></mat-divider>

  <div class="fd-totals-row fd-totals-total">
    <strong>Total</strong>
    <strong>${{ total | number:'1.2-2' }}</strong>
  </div>
</div>
